export const AXIOM_FORMS_PREFIX = 'AxiomForms.';

export const METADATA_TYPE_KEY = 'metadata';

export enum FormSubmissionStatus {
    SUBMITTED = 'Submitted',
    DRAFT = 'Draft',
    DISCARDED = 'Discarded'
}